/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<circle
				opacity="0.4"
				cx="17"
				cy="5"
				r="3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 22H9H5.86133C3.95219 22 2.99762 22 2.46471 21.601C2.0003 21.2534 1.70974 20.7211 1.66841 20.1425C1.62099 19.4785 2.13718 18.6755 3.16956 17.0696L6.30823 12.1872C7.20408 10.7937 7.652 10.0969 8.22156 9.85622C8.71922 9.64595 9.28078 9.64595 9.77844 9.85622C10.348 10.0969 10.7959 10.7937 11.6918 12.1872L14.5 16.5556M18 22H18.1387C20.0478 22 21.0024 22 21.5353 21.601C21.9997 21.2534 22.2903 20.7211 22.3316 20.1425C22.379 19.4785 21.8628 18.6755 20.8304 17.0696L20.1918 16.0761C19.2959 14.6825 18.848 13.9858 18.2784 13.7451C17.7808 13.5348 17.2192 13.5348 16.7216 13.7451C16.152 13.9858 15.7041 14.6825 14.8082 16.0761L14.5 16.5556M18 22L14.5 16.5556"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M20 5C20 6.65685 18.6569 8 17 8C15.3431 8 14 6.65685 14 5C14 3.34315 15.3431 2 17 2C18.6569 2 20 3.34315 20 5Z"
					fill="currentColor"
				/>
				<path
					d="M5.86133 22C3.95219 22 2.99762 22 2.46471 21.601C2.0003 21.2534 1.70974 20.7211 1.66841 20.1425C1.62099 19.4785 2.13718 18.6755 3.16956 17.0696L6.30823 12.1872C7.20408 10.7937 7.652 10.0969 8.22156 9.85622C8.71922 9.64595 9.28078 9.64595 9.77844 9.85622C10.348 10.0969 10.7959 10.7937 11.6918 12.1872L14.5 16.5556L14.8082 16.0761C15.7041 14.6825 16.152 13.9858 16.7216 13.7451C17.2192 13.5348 17.7808 13.5348 18.2784 13.7451C18.848 13.9858 19.2959 14.6825 20.1918 16.0761L20.8304 17.0696C21.8628 18.6755 22.379 19.4785 22.3316 20.1425C22.2903 20.7211 21.9997 21.2534 21.5353 21.601C21.0024 22 20.0478 22 18.1387 22H18H9H5.86133Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M18 22H9H5.86133C3.95219 22 2.99762 22 2.46471 21.601C2.0003 21.2534 1.70974 20.7211 1.66841 20.1425C1.62099 19.4785 2.13718 18.6755 3.16956 17.0696L6.30823 12.1872C7.20408 10.7937 7.652 10.0969 8.22156 9.85622C8.71922 9.64595 9.28078 9.64595 9.77844 9.85622C10.348 10.0969 10.7959 10.7937 11.6918 12.1872L14.5 16.5556M18 22H18.1387C20.0478 22 21.0024 22 21.5353 21.601C21.9997 21.2534 22.2903 20.7211 22.3316 20.1425C22.379 19.4785 21.8628 18.6755 20.8304 17.0696L20.1918 16.0761C19.2959 14.6825 18.848 13.9858 18.2784 13.7451C17.7808 13.5348 17.2192 13.5348 16.7216 13.7451C16.152 13.9858 15.7041 14.6825 14.8082 16.0761L14.5 16.5556M18 22L14.5 16.5556M20 5C20 6.65685 18.6569 8 17 8C15.3431 8 14 6.65685 14 5C14 3.34315 15.3431 2 17 2C18.6569 2 20 3.34315 20 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M13.25 5C13.25 2.92893 14.9289 1.25 17 1.25C19.071 1.25 20.75 2.92893 20.75 5C20.75 7.07107 19.071 8.75 17 8.75C14.9289 8.75 13.25 7.07107 13.25 5Z"
				fill="currentColor"
			/>
			<path
				d="M11.6917 10.8003C10.7959 9.40671 10.348 8.70994 9.77841 8.46928C9.28075 8.259 8.71919 8.259 8.22153 8.46928C7.65197 8.70994 7.20405 9.40671 6.3082 10.8003L3.38056 15.3544C1.83199 17.7633 1.0577 18.9677 1.12884 19.9637C1.19084 20.8317 1.62667 21.63 2.32328 22.1515C3.12265 22.75 4.55451 22.75 7.41821 22.75H16.5817C19.4454 22.75 20.8773 22.75 21.6767 22.1515C22.3733 21.63 22.8091 20.8317 22.8711 19.9637C22.9422 18.9677 22.168 17.7633 20.6194 15.3544L19.5 13.6131C19.22 13.1775 19.08 12.9597 18.9496 12.8226C18.1612 11.9931 16.8388 11.9931 16.0504 12.8226C15.92 12.9597 15.78 13.1775 15.5 13.6131C15.36 13.8308 15.29 13.9397 15.2248 14.0083C14.8306 14.423 14.1694 14.423 13.7752 14.0083C13.71 13.9397 13.64 13.8308 13.5 13.6131L11.6917 10.8003Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M18 22H9H4.16083C3.73202 22 3.51762 22 3.37344 21.9789C2.05697 21.786 1.29231 20.3854 1.84198 19.1738C1.90218 19.0411 2.01812 18.8607 2.25 18.5V18.5L3 17.3333M18 22H18.1387C20.0478 22 21.0024 22 21.5353 21.601C21.9997 21.2534 22.2903 20.7211 22.3316 20.1425C22.379 19.4785 21.8628 18.6755 20.8304 17.0696L20.1918 16.0761C19.2959 14.6825 18.848 13.9858 18.2784 13.7451C17.7808 13.5348 17.2192 13.5348 16.7216 13.7451C16.152 13.9858 15.7041 14.6825 14.8082 16.0761L14.5 16.5556M18 22L14.5 16.5556M14.5 16.5556L11.25 11.5C10.7488 10.7204 10.4983 10.3306 10.2298 10.1213C9.50681 9.5576 8.49319 9.5576 7.77024 10.1213C7.50175 10.3306 7.25117 10.7204 6.75 11.5V11.5L5.14286 14M20 5C20 6.65685 18.6569 8 17 8C15.3431 8 14 6.65685 14 5C14 3.34315 15.3431 2 17 2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 22H9H5.86133C3.95219 22 2.99762 22 2.46471 21.601C2.0003 21.2534 1.70974 20.7211 1.66841 20.1425C1.62099 19.4785 2.13718 18.6755 3.16956 17.0696L6.30823 12.1872C7.20408 10.7937 7.652 10.0969 8.22156 9.85622C8.71922 9.64595 9.28078 9.64595 9.77844 9.85622C10.348 10.0969 10.7959 10.7937 11.6918 12.1872L14.5 16.5556M18 22H18.1387C20.0478 22 21.0024 22 21.5353 21.601C21.9997 21.2534 22.2903 20.7211 22.3316 20.1425C22.379 19.4785 21.8628 18.6755 20.8304 17.0696L20.1918 16.0761C19.2959 14.6825 18.848 13.9858 18.2784 13.7451C17.7808 13.5348 17.2192 13.5348 16.7216 13.7451C16.152 13.9858 15.7041 14.6825 14.8082 16.0761L14.5 16.5556M18 22L14.5 16.5556M20 5C20 6.65685 18.6569 8 17 8C15.3431 8 14 6.65685 14 5C14 3.34315 15.3431 2 17 2C18.6569 2 20 3.34315 20 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M11.6917 10.8005C10.7959 9.40694 10.348 8.71017 9.77841 8.46951C9.28075 8.25923 8.71919 8.25923 8.22153 8.46951C7.65197 8.71017 7.20405 9.40694 6.3082 10.8005L3.38056 15.3546C1.83199 17.7635 1.0577 18.9679 1.12884 19.964C1.19084 20.8319 1.62667 21.6303 2.32328 22.1518C3.12265 22.7502 4.55451 22.7502 7.41821 22.7502H16.5817C19.4454 22.7502 20.8773 22.7502 21.6767 22.1518C22.3733 21.6303 22.8091 20.8319 22.8711 19.964C22.9422 18.9679 22.168 17.7635 20.6194 15.3546L19.5 13.6133C19.22 13.1777 19.08 12.96 18.9496 12.8228C18.1612 11.9933 16.8388 11.9933 16.0504 12.8228C15.92 12.96 15.78 13.1777 15.5 13.6133C15.36 13.8311 15.29 13.9399 15.2248 14.0085C14.8306 14.4233 14.1694 14.4233 13.7752 14.0085C13.71 13.9399 13.64 13.8311 13.5 13.6133L11.6917 10.8005Z"
				fill="currentColor"
			/>
			<path
				d="M13.25 5C13.25 2.92893 14.9289 1.25 17 1.25C19.0711 1.25 20.75 2.92893 20.75 5C20.75 7.07107 19.0711 8.75 17 8.75C14.9289 8.75 13.25 7.07107 13.25 5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
